import React, { useEffect, useMemo, useState } from "react";
import VerticalMenu from '../VerticalMenu';
import Icon from '@cloud/atom-ui-icons';
import i18n from '@src/i18n';
import history from "../../utils/history";
import { queryString } from '../../utils/common';
import useMappedState from '@src/utils/useMappedState';
import { getMenus } from '../../utils/joint-request';
import { useDispatch } from 'redux-react-hook';
import * as actions from "@src/actions/index";

import infoIcon from './assets/info.svg';
import infoActiveIcon from './assets/info_active.svg';
import personIcon from './assets/person.svg';
import personActiveIcon from './assets/person_active.svg';
import manageIcon from './assets/manage.svg';
import namageActiveIcon from './assets/manage_active.svg';
import reportsIcon from './assets/reports.svg';
import reportsActiveIcon from './assets/reports_active.svg';
import logIcon from './assets/log.svg';
import logActiveIcon from './assets/log_active.svg';
import addIcon from './assets/add.svg';
import addActiveIcon from './assets/add_active.svg';
import releasedIcon from './assets/released.svg'
import releasedActiveIcon from './assets/released_active.svg'
import eventCallbackIcon from './assets/eventCallback.svg'
import eventCallbackActiveIcon from './assets/eventCallback_active.svg'
import projectConfigIcon from './assets/project_config.svg'
import projectConfigActiveIcon from './assets/project_config_active.svg'
import entryGroupNotificationIcon from './assets/entry_group_notification.svg'
import entryGroupNotificationActiveIcon from './assets/entry_group_notification_active.svg'
import operationManagementIcon from './assets/operationManagement.svg'
import operationManagementActiveIcon from './assets/operationManagement_active.svg'
import { ABILITY_LIST } from "../../utils/constant";

const SiderMenu = props => {
  const { currentKey, setCurrentKey } = props;
  const { abilityMenuList, appBaseInfo } = useMappedState('root');
  const [initFlag, setInitFlag] = useState(0);
  const appId = queryString("appId");
  const dispatch = useDispatch();

  const routerConfig = {
    // 凭证与基本信息
    appBaseInfo: "/appBaseInfo",
    // 成员管理
    memberManage: "/memberManage",
    // api管理
    appApiManage: "/appApiManage",
    // 添加应用能力
    addAbility: "/addAbility",
    // 能力
    appCapabilitiesList: "/appCapabilitiesList",
    // 微码能力
    appCapabilitiesWecode: "/appCapabilitiesWecode",
    // 版本发布与审核
    versionRelease: "/versionRelease",
    // 事件与回调
    eventCallback: "/eventCallback",
    // 项目配置
    projectConfiguration: '/projectConfiguration',
    // 入群通知设置
    entryGroupNotification: '/entryGroupNotification',
    // 运行管理
    operationManagement: '/operationManagement'
  };

  const infoActiveImg = () => <img src={infoActiveIcon} />;
  const infoImg = () => <img src={infoIcon} />;
  const personActiveImg = () => <img src={personActiveIcon} />;
  const personImg = () => <img src={personIcon} />;
  const manageActiveImg = () => <img src={namageActiveIcon} />;
  const manageImg = () => <img src={manageIcon} />;
  const reportsActiveImg = () => <img src={reportsActiveIcon} />;
  const reportsImg = () => <img src={reportsIcon} />;
  const logActiveImg = () => <img src={logActiveIcon} />;
  const logImg = () => <img src={logIcon} />;
  const addActiveImg = () => <img src={addActiveIcon} />;
  const addImg = () => <img src={addIcon} />;
  const releasedActiveImg = () => <img src={releasedActiveIcon} />;
  const releasedImg = () => <img src={releasedIcon} />;
  const eventCallbackActiveImg = () => <img src={eventCallbackActiveIcon} />;
  const eventCallbackImg = () => <img src={eventCallbackIcon} />;
  const projectConfigActiveImg = () => <img src={projectConfigActiveIcon} />;
  const projectConfigImg = () => <img src={projectConfigIcon} />;
  const entryGroupNotificationActiveImg = () => <img src={entryGroupNotificationActiveIcon} />;
  const entryGroupNotificationImg = () => <img src={entryGroupNotificationIcon} />;
  const operationManagementActiveImg = () => <img  src={operationManagementActiveIcon} />;
  const operationManagementImg = () => <img  src={operationManagementIcon} />;

  const initList = [
    {
      moduleName: i18n.t('home:baseInfo'),
      children: [
        {
          label: i18n.t('home:credentials'),
          key: 'appBaseInfo',
          activeIcon: <Icon component={infoActiveImg} />,
          icon: <Icon component={infoImg} />,
          path: routerConfig.appBaseInfo,
        },
        {
          label: i18n.t('home:personManage'),
          key: 'memberManage',
          activeIcon: <Icon component={personActiveImg} />,
          icon: <Icon component={personImg} />,
          path: routerConfig.memberManage,
        },
      ]
    },
    {
      moduleName: i18n.t('home:appSkills'),
      children: [
        {
          label: i18n.t('home:addAppSkills'),
          key: 'addAbility',
          activeIcon: <Icon component={addActiveImg} />,
          icon: <Icon component={addImg} />,
          path: routerConfig.addAbility,
        },
      ]
    },
    {
      moduleName: i18n.t('home:devConfig'),
      children: [
        {
          label: i18n.t('home:apiManage'),
          key: 'appApiManage',
          activeIcon: <Icon component={manageActiveImg} />,
          icon: <Icon component={manageImg} />,
          path: routerConfig.appApiManage,
        },
        {
          label: i18n.t('home:eventCallback'),
          key: 'eventCallback',
          activeIcon: <Icon component={eventCallbackActiveImg} />,
          icon: <Icon component={eventCallbackImg} />,
          path: routerConfig.eventCallback
        },
        {
          label: i18n.t('home:projectConfiguration'),
          key: 'projectConfiguration',
          activeIcon: <Icon component={projectConfigActiveImg} />,
          icon: <Icon component={projectConfigImg} />,
          path: routerConfig.projectConfiguration
        },
        {
          label: i18n.t('home:entryGroupNotification'),
          key: 'entryGroupNotification',
          activeIcon: <Icon component={entryGroupNotificationActiveImg} />,
          icon: <Icon component={entryGroupNotificationImg} />,
          path: routerConfig.entryGroupNotification
        },
      ]
    },
    {
      moduleName: i18n.t('home:operateMonitoring'),
      isHidden: true,
      children: [
        {
          label: i18n.t('home:operateReport'),
          key: '6',
          activeIcon: <Icon component={reportsActiveImg} />,
          icon: <Icon component={reportsImg} />,
        },
        {
          label: i18n.t('home:operateLog'),
          key: '7',
          activeIcon: <Icon component={logActiveImg} />,
          icon: <Icon component={logImg} />,
        },
      ]
    },
    {
      moduleName: i18n.t('home:operationalMonitoring'),
      children: [
        {
          label: i18n.t('home:operationManagement'),
          key: 'operationManagement',
          activeIcon: <Icon component={operationManagementActiveImg} />,
          icon: <Icon component={operationManagementImg} />,
          path: routerConfig.operationManagement
        },
      ]
    },
    {
      moduleName: i18n.t('home:versionManage'),
      children: [
        {
          label: i18n.t('home:versionRelease'),
          key: 'versionRelease',
          activeIcon: <Icon component={releasedActiveImg} />,
          icon: <Icon component={releasedImg} />,
          path: routerConfig.versionRelease
        },
      ]
    },
  ];

  const menuList = useMemo(() => {
    if (abilityMenuList?.appId !== appId || !abilityMenuList?.list?.length) return initList;
    const newList = abilityMenuList?.list?.map(item => {
      return {
        label: item?.abilityNameCn,
        key: `${item?.abilityType}`,
        activeIcon: <Icon component={() => <img src={item?.iconUrl} />} />,
        icon: <Icon component={() => <img src={item?.iconUrl} />} />,
        path: item?.abilityType === ABILITY_LIST.Wecode ? routerConfig.appCapabilitiesWecode : routerConfig.appCapabilitiesList,
      }
    });
    return initList?.map(item => {
      if (item?.moduleName === i18n.t('home:appSkills')) {
        item.children = [...item.children, ...newList]
      }
      return item
    });
  }, [abilityMenuList]);

  const onClickMenu = item => {
    setCurrentKey(item?.key);
    if (item?.path === routerConfig.appCapabilitiesList || item?.path === routerConfig.appCapabilitiesWecode) {
      history.push(`${item?.path}?appId=${appId}&operateType=${item?.key}`);
    } else {
      history.push(`${item?.path}?appId=${appId}`);
    }
  };

  useEffect(() => {
    if (appBaseInfo?.appType && !initFlag) {
      setInitFlag(initFlag + 1);
      getMenus(appId, dispatch);
    }
  }, [appBaseInfo, initFlag]);

  return (
    <VerticalMenu onClick={onClickMenu} selectedKeys={currentKey} menus={menuList} />
  )
};

export default SiderMenu;
